import { Grid, Typography } from '@mui/material';

import { useSelector } from 'react-redux';

import DOMPurify from 'dompurify';

import { RootState } from 'common/store/AppStore';
import { toSentenceCase } from 'common/utils/utilFunctions';

import styles from '../../HorizonDetailLayout/HorizonDetailLayout.module.scss';

import { Loader } from '../ActionPlanLayout/ActionPlanTaskTableModules';
import ApplicabilityDropdown from '../ApplicabilityDropdown/ApplicabilityDropdown';

const DocumentSection = (props: any) => {
	const {
		data,
		openCommentsSection,
		makeAPICall,
		isLoading,
		commentsSectionRef,
		scrollToCommentsSection,
	} = props;

	const currentWorkflowStatus = useSelector(
		(state: RootState) => state.horizonScan.currentWorkflowStatus,
	);

	return (
		<div className={styles['document-section-container']}>
			<div>
				<Grid container className={styles['document-header-container']}>
					<Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
						<Typography variant="h6" gutterBottom>
							{toSentenceCase('Source data')}
						</Typography>
					</Grid>
					<Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
						<ApplicabilityDropdown
							commentsSectionRef={commentsSectionRef}
							scrollToCommentsSection={scrollToCommentsSection}
							data={data}
							stepperStatus={currentWorkflowStatus}
							openCommentsSection={openCommentsSection}
							makeAPICall={makeAPICall}
						/>
					</Grid>
				</Grid>
			</div>
			{data?.informationText && (
				<div>
					<Typography className={styles.textarea}>
						<div
							dangerouslySetInnerHTML={{
								__html: DOMPurify.sanitize(data?.informationText || '').replace(
									/<a /g,
									'<a target="_blank" ',
								),
							}}
						/>
					</Typography>
				</div>
			)}
			{isLoading && (
				<Loader show={isLoading} className={styles['loader-styling']} />
			)}
		</div>
	);
};

export default DocumentSection;
